import { IStoreRootState } from "@/store/interface";
import { ActionTree } from "vuex";
import { $createPaymentRequirements, $deletePaymentRequirementsFile, $getPaymentRequirementsCardIndexDetails, $getPaymentRequirementsFiles, $getPaymentRequirementsUnprocessed, $refusePaymentRequirements, $signPaymentRequirementsIncoming, $uploadPaymentRequirementsFile } from "../../api/incoming/payment-requirements-incoming";
import { PaymentRequirementsCardIndexDetailsItem, PaymentRequirementsCardIndexItem, PaymentRequirementsIncomingSignResponse, PaymentRequirementsItem } from "../../api/incoming/payment-requirements-incoming.interface";
import { PaymentRequirementsIncomingAction, PaymentRequirementsIncomingGetter, PaymentRequirementsIncomingMutation } from "./constants";
import { PaymentRequirementsIncomingState } from "./interface";
import { DigitalSignCommonData } from '@/mixins/crk/interface';
import { FileDeleteParams, FileLoaderParams, FileObjectItem, FileUploadParams } from "@/api/files/interface";
import { FileListItem } from "@/components/IBFile/interface";
import { CancelableApiResponse, IApiHandlerParams } from "@/api/interface";

export default <ActionTree<PaymentRequirementsIncomingState, IStoreRootState>> {

	async [PaymentRequirementsIncomingAction.loadUnprocessed](
		{ commit },
		handler?: IApiHandlerParams
	): Promise<PaymentRequirementsItem[] | null> {
		commit(PaymentRequirementsIncomingMutation.setUnprocessedListLoading, true);

		const unprocessedList = await $getPaymentRequirementsUnprocessed(handler);

		commit(PaymentRequirementsIncomingMutation.setUnprocessedList, unprocessedList || []);
		commit(PaymentRequirementsIncomingMutation.setUnprocessedListLoading, false);

		return unprocessedList;
	},

	async [PaymentRequirementsIncomingAction.signUnprocessed](
		{},
		payload: DigitalSignCommonData
	): Promise<PaymentRequirementsIncomingSignResponse | null> {
		return $signPaymentRequirementsIncoming(payload);
	},

	async [PaymentRequirementsIncomingAction.loadCardIndexDetails](
		{},
		payload: PaymentRequirementsCardIndexItem
	): Promise<PaymentRequirementsCardIndexDetailsItem | null> {
		return payload.documentIdInk
			? $getPaymentRequirementsCardIndexDetails({
				kId: payload.documentIdInk
			}, { disableLoader: true })
			: null;
	},

	async [PaymentRequirementsIncomingAction.cachedLoadCardIndexDetails](
		{ getters, commit, dispatch },
		payload: PaymentRequirementsCardIndexItem
	): Promise<PaymentRequirementsCardIndexDetailsItem | null> {
		const cardIndexDetails = getters[PaymentRequirementsIncomingGetter.cardIndexDetails];

		if (payload.documentIdInk
			&& !cardIndexDetails[payload.documentIdInk]) {
			const payment = await dispatch(
				PaymentRequirementsIncomingAction.loadCardIndexDetails,
				payload
			);

			commit(
				PaymentRequirementsIncomingMutation.setCardIndexDetails,
				{ ...payload, ...(payment || {}), }
			);
		}

		return (payload.documentIdInk
			&& cardIndexDetails[payload.documentIdInk])
			|| null;
	},

	async [PaymentRequirementsIncomingAction.uploadDenieFile](
		{},
		payload: FileUploadParams
	): Promise<CancelableApiResponse<FileObjectItem | null>> {
		return $uploadPaymentRequirementsFile(payload);
	},

	async [PaymentRequirementsIncomingAction.deleteDenieFile](
		{},
		payload: FileDeleteParams
	): Promise<boolean> {
		return $deletePaymentRequirementsFile(payload);
	},

	async [PaymentRequirementsIncomingAction.loadDenieFiles](
		{},
		payload: FileLoaderParams
	): Promise<FileListItem[]> {
		return $getPaymentRequirementsFiles(payload);
	},

	async [PaymentRequirementsIncomingAction.refusePayment](
		{},
		payload: DigitalSignCommonData
	): Promise<boolean> {
		return $refusePaymentRequirements(payload);
	},

	async [PaymentRequirementsIncomingAction.createPayment](
		{},
		payload: DigitalSignCommonData
	): Promise<boolean> {
		return $createPaymentRequirements(payload);
	},

}